import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const TICKET_DETAILS = FORM_FIELDS.E_TICKET.TICKET_DETAILS;

const { STATUS, ASSIGNED_TO } = TICKET_DETAILS;

export const ticketFormValidation = yup.object().shape({
  [STATUS]: yup
    .string()
    .typeError("Status is required")
    .required("Status is required"),
  [ASSIGNED_TO]: yup
    .number()
    .typeError("You Must Assign Someone")
    .required("You Must Assign Someone"),
});

export type TicketFormDataType = yup.InferType<typeof ticketFormValidation>;
